import React, { useState } from "react";
import useSWR from "swr";
import dayjs from "dayjs";
import { fetcherhn } from "../../services/fectcher";
import {
  Button,
  Space,
  Table,
  Popconfirm,
  Drawer,
  Tooltip,
  Skeleton,
} from "antd";
import Search from "antd/es/input/Search";

import AddAdmReAdm from "./AddAdmReAdm";
import { deleteAdmRadm } from "../../api/CareEventsApi";
import { WarningOutlined } from "@ant-design/icons";
import { openNotification } from "../../common/elements/myNotification";
import { useMyContext } from "../../common/elements/myContext";

import { FaEdit, FaMobileAlt, FaRegTrashAlt } from "react-icons/fa";
import { FiSend } from "react-icons/fi";
import SendEmail from "../../common/elements/SendEmail";
import { MdEventNote } from "react-icons/md";

const AdmReAdm = ({ patient }) => {
  const intialReqState = {
    key: "",
    guid: "",
    mbi: patient?.value,
    lob: "",
    admissionType: "Admission",
    dateOfAdmission: dayjs().format("YYYY-MM-DD"),
    patientLocation: "",
    facilityName: "",
    roomNumber: "",
    healthPlan: "",
    createdBy: sessionStorage.getItem("userName") || "",
    modifiedBy: "",
    skilledOrCustodial: "Skilled",
    policyNumber: "",
    ssn: "",
    providerNameLabel: "",
    providerNameValue: "",
    providerNameOther: "",
    nporpaLabel: "",
    nporpaValue: "",
    nporpaOther: "",
    callerName: "",
    callerRelationshipPatient: "",
    nurseStation: "",
    callBackNumber: "",
    message: "",
    messageSentTo: "",
    attachmentLinks: "",
    callBackNumberExt: "",
  };

  const { utcToLocal } = useMyContext();
  const [editRecord, setEditRecord] = useState(intialReqState);
  const [query, setQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, mutate, isLoading } = useSWR(
    `/GetTriggerAdmissionReadmission?id=${patient?.value}`,
    fetcherhn
  );

  const { formatPhoneNumber } = useMyContext();

  const { data: nppa } = useSWR("GetNpPaList", fetcherhn);

  const [mail, setMail] = useState(false);

  const sendDatatoEmail = (record) => {
    setMail(true);
    setEditRecord(record);
  };

  const handleCancel = (e) => {
    setIsModalOpen(false);
    setEditRecord(intialReqState);
  };

  const handleModalClose = (e) => {
    setEditRecord(intialReqState);
    setMail(false);
  };

  const handleOk = async (e) => {
    if (e) {
      mutate();
    }
    setIsModalOpen(false);
    setEditRecord(intialReqState);
  };

  const handleDelete = async (record) => {
    const body = { ...record, modifiedBy: sessionStorage.getItem("userName") };
    for (let key in body) {
      if (body[key] === null) {
        body[key] = "";
      }
    }
    const deleteResult = await deleteAdmRadm(body);
    if (deleteResult.status) {
      mutate();
      openNotification(
        "success",
        "Deleted",
        "Admission / Re-Admission Deleted Successfully!"
      );
    }
  };

  const edit = (record) => {
    setIsModalOpen(true);
    setEditRecord(record);
  };

  const columns = [
    {
      key: 1,
      title: "Admission / Re-Admission",
      dataIndex: "admissionType",
      width: 150,
    },
    // {
    //   key: 2,
    //   title: "Date of Birth",
    //   render: () => <div>{patient?.label.split(" - ")[1]}</div>,
    //   width: 150,
    // },
    {
      key: 3,
      title: "Date",
      dataIndex: "dateOfAdmission",
      width: 150,
    },
    {
      key: 3,
      title: "Skilled / Custodial",
      dataIndex: "skilledOrCustodial",
      width: 150,
    },

    {
      key: 4,
      title: "Patient Home Address",
      dataIndex: "patientLocation",
      width: 200,
    },
    {
      key: 5,
      title: "Facility",
      dataIndex: "facilityName",
      width: 200,
    },
    {
      key: 6,
      title: "Room #",
      dataIndex: "roomNumber",
      width: 150,
    },
    {
      key: 7,
      title: "Health Plan / Medical Group",
      dataIndex: "healthPlan",
      width: 250,
    },
    {
      key: 7,
      title: "Policy Number",
      dataIndex: "policyNumber",
      width: 150,
    },
    {
      key: 7,
      title: "SSN",
      dataIndex: "ssn",
      width: 150,
    },
    {
      key: "nppa",
      title: "NP/PA",
      dataIndex: "nporpaLabel",
      width: 150,
      render: (_, data) => {
        return (
          <>
            <div>{data.nporpaLabel}</div>
            {data.nporpaLabel === "Other" && (
              <div className=" tw-text-gray-500">
                <MdEventNote size={20} className=" tw-mr-1 tw-text-gray-400" />
                {data.nporpaOther}
              </div>
            )}
          </>
        );
      },
    },
    {
      key: "pn",
      title: "Provider",
      dataIndex: "providerNameLabel",
      width: 150,

      render: (_, data) => {
        return (
          <>
            <div>{data.providerNameLabel}</div>
            {data.providerNameLabel === "Other" && (
              <div className=" tw-text-gray-500">
                <MdEventNote size={20} className=" tw-mr-1 tw-text-gray-400" />
                {data.providerNameOther}
              </div>
            )}
          </>
        );
      },
    },
    {
      key: 4,
      title: "Caller Name",
      dataIndex: "callerName",
      width: 150,
    },
    {
      key: 5,
      title: "Caller Relationship to Patient",
      dataIndex: "callerRelationshipPatient",
      width: 150,
    },
    {
      key: 6,
      title: "Nurse Station",
      dataIndex: "nurseStation",
      width: 150,
    },
    {
      key: 7,
      title: "Call back number",
      dataIndex: "callBackNumber",
      width: 200,
      render: (_, { callBackNumber, callBackNumberExt }) => (
        <>
          {callBackNumber ? (
            <div
              style={{
                fontSize: "0.9rem",
                color: "var(--bs-gray-600)",
                marginBottom: "0.3rem",
                marginTop: "0.3rem",
                overflowWrap: "break-word",
              }}
            >
              <FaMobileAlt
                size={20}
                style={{
                  color: "var(--bs-gray-500)",
                  marginRight: "0.5rem",
                  marginTop: "-2px",
                }}
              />
              <a href={`tel:${formatPhoneNumber(callBackNumber)}`}>
                {formatPhoneNumber(callBackNumber)}
              </a>
              <p className="tw-text-black tw-mt-2">
                {callBackNumberExt && <> Ext. {callBackNumberExt}</>}
              </p>
            </div>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      key: 9,
      title: "Message",
      dataIndex: "message",
      width: 300,
    },
    {
      key: 10,
      title: "Message sent to",
      dataIndex: "messageSentTo",
      width: 150,
    },
    {
      key: 9,
      title: "Attachment Links",
      dataIndex: "attachmentLinks",
      width: 200,
      render: (text) => (
        <>
          {text?.split(",").map((link, index) => (
            <span key={index}>
              <a href={link.trim()}>{link.trim()}</a>
              {index < text.split(",").length - 1 ? ", " : ""}
            </span>
          ))}
        </>
      ),
    },
    {
      key: 8,
      title: "Note Date & Time",
      width: 150,
      render: (_, { createdDateTime, createdBy }) => {
        return (
          <>
            <div>{utcToLocal(createdDateTime)}</div>
            <div>{createdBy.split("@")[0]}</div>
          </>
        );
      },
    },
    {
      key: "key",
      title: "Operation",
      dataIndex: "guid",
      fixed: "right",
      width: 150,
      render: (_, record) => (
        <div>
          <Space>
            <Tooltip title="Edit">
              <FaEdit
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => edit(record)}
                color="blue"
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Popconfirm
                title="Ok to Delete?"
                onConfirm={() => handleDelete(record)}
                icon={
                  <WarningOutlined
                    style={{
                      color: "red",
                    }}
                  />
                }
              >
                <FaRegTrashAlt
                  size={20}
                  className=" tw-cursor-pointer"
                  color="red"
                />
              </Popconfirm>
            </Tooltip>
            <Tooltip title="Send Email">
              <FiSend
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => sendDatatoEmail(record)}
                color="green"
              />
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];

  const finalResult = data
    ? data.filter((item) => {
        return [
          "admissionType",
          "facilityName",
          "roomNumber",
          "patientLocation",
          "healthPlan",
          "dateOfBirth",
          "dateOfAdmission",
          "createdBy",
          "createdDateTime",
          "skilledOrCustodial",
          "policyNumber",
          "ssn",
          "providerNameLabel",
          "providerNameOther",
          "nporpaLabel",
          "nporpaOther",
          "callerName",
          "callerRelationshipPatient",
          "nurseStation",
          "callBackNumber",
          "message",
          "messageSentTo",
          "callBackNumberExt",
          "attachmentLinks",
        ].some((key) =>
          (item[key]?.toString()?.toLowerCase() ?? "").includes(
            query?.toLowerCase() ?? ""
          )
        );
      })
    : data;

  if (isLoading) {
    return <Skeleton active={isLoading} />;
  }

  return (
    <div>
      <div className="tw-flex tw-justify-between ">
        <p
          className="pt-3"
          style={{
            color: "#D2691E",
            fontWeight: "600",
          }}
        >
          Admission / Re-Admission
        </p>

        <div className="tw-flex tw-justify-end  tw-mt-3 ">
          <Space>
            <Search
              className=" tw-mb-4"
              size="middle"
              placeholder="Search"
              onChange={(e) => setQuery(e.target.value)}
              allowClear
            />
            <Button
              type="primary"
              onClick={() => setIsModalOpen(true)}
              className="tw-mb-4 "
            >
              Add
            </Button>
          </Space>
        </div>
      </div>
      {isModalOpen && (
        <Drawer
          open={isModalOpen}
          title={"Add/Update Admission/Re-Admission"}
          onClose={handleCancel}
          width={800}
        >
          <AddAdmReAdm
            editRecord={editRecord}
            callback={handleOk}
            nppa={nppa}
          />
        </Drawer>
      )}
      <Table
        bordered
        dataSource={finalResult}
        columns={columns}
        scroll={{
          x: 2000,
          y: 1000,
        }}
      />

      {mail && (
        <SendEmail
          open={mail}
          close={handleModalClose}
          editRecord={editRecord}
          modalTitle={"Admission / Re-Admission"}
          patientName={patient?.label}
        />
      )}
    </div>
  );
};

export default AdmReAdm;
